import { m, useReducedMotion } from "framer-motion";
import type { ReactNode } from "react";
import { fadeInUp } from "./variants";

interface RevealProps {
  children: ReactNode;
  className?: string;
  /** Extra delay in seconds before the reveal starts. */
  delay?: number;
}

/** Reveals content with a fade + rise the first time it scrolls into view. */
export function Reveal({ children, className, delay = 0 }: RevealProps) {
  const reducedMotion = useReducedMotion();

  // A reveal starts at opacity 0 and only becomes visible once the viewport
  // observer fires. Reduced motion skips the rise but not the fade, so the
  // content would still blank out for a frame and then fade in. Render it
  // outright instead.
  if (reducedMotion) {
    return <div className={className}>{children}</div>;
  }

  return (
    <m.div
      className={className}
      variants={fadeInUp}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.25 }}
      transition={{ delay }}
    >
      {children}
    </m.div>
  );
}
